import type { PossibleRiderLabel } from '../types/lifecycle';

interface RiderBadgeProps {
  label: PossibleRiderLabel;
}

export function RiderBadge({ label }: RiderBadgeProps) {
  const className = label === 'prilepek' ? 'badge--rider-confirmed' : 'badge--rider-possible';
  const text = label === 'prilepek' ? 'Přílepek' : 'Možný přílepek';
  return <span className={`badge ${className}`}>{text}</span>;
}
